
export default {
	name: 'DeleteResult',
};
